/* PLYOFOLD homepage runtime — dependency-free port of the design-concept
   prototype (Claude Design V3 motion set). Horizon scrolls an inner
   .page-wrapper on desktop (html/body are overflow:hidden), so all scroll
   plumbing here is scroller-agnostic: a capturing document scroll listener
   catches every scroller, and all geometry is viewport-rect based.
   Reduced motion: scrub/counts/floats/reveals do not register; the fold is
   driven by its slider and all content renders as laid out. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('pf-js');

  /* ---------- header state + world ---------- */
  var header = document.querySelector('.pf-header');
  var hero = document.querySelector('.pf-hero');
  var themed = Array.prototype.slice.call(document.querySelectorAll('[data-pf-theme]'));
  function syncHeader() {
    if (header) {
      var solid = true;
      if (hero) solid = hero.getBoundingClientRect().top < -32;
      header.setAttribute('data-solid', String(solid));
    }
    var world = themed.length ? 'dark' : 'light';
    for (var i = 0; i < themed.length; i++) {
      var r = themed[i].getBoundingClientRect();
      if (r.top <= 80 && r.bottom > 80) world = themed[i].getAttribute('data-pf-theme') === 'light' ? 'light' : 'dark';
    }
    if (document.body.getAttribute('data-pf-world') !== world) document.body.setAttribute('data-pf-world', world);
  }

  var ticking = false;
  function onAnyScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      try {
        syncHeader();
        foldScrub();
        floats();
      } finally {
        ticking = false;
      }
    });
  }
  // Capture phase: fires for window AND any inner scroller (.page-wrapper).
  document.addEventListener('scroll', onAnyScroll, true);
  window.addEventListener('resize', onAnyScroll);

  /* ---------- mobile nav ---------- */
  var burger = document.querySelector('.pf-burger');
  var mnav = document.querySelector('.pf-mobile-nav');
  if (burger && mnav) {
    var closeNav = function () {
      burger.setAttribute('aria-expanded', 'false');
      mnav.hidden = true;
      document.body.style.overflow = '';
    };
    burger.addEventListener('click', function () {
      var open = burger.getAttribute('aria-expanded') === 'true';
      if (open) { closeNav(); return; }
      burger.setAttribute('aria-expanded', 'true');
      mnav.hidden = false;
      document.body.style.overflow = 'hidden';
    });
    mnav.addEventListener('click', function (e) { if (e.target.closest('a')) closeNav(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !mnav.hidden) { closeNav(); burger.focus(); } });
  }

  /* ---------- fold stage (M-10) ---------- */
  var tall = document.querySelector('.pf-fold-tall');
  var stage = document.querySelector('.pf-fold-stage');
  var range = document.getElementById('pf-fold-range');
  var chip = document.getElementById('pf-fold-chip');
  var openFig = document.querySelector('.pf-fold-open');
  var closedFig = document.querySelector('.pf-fold-closed');
  var steps = Array.prototype.slice.call(document.querySelectorAll('.pf-step'));
  var STEPS = ['Status — Open', 'Status — Trainen', 'Status — Vouwen', 'Status — Opgeborgen'];

  function setFold(t) {
    if (!stage) return;
    t = Math.min(1, Math.max(0, t));
    stage.style.setProperty('--fold', String(t));
    if (openFig) openFig.setAttribute('aria-hidden', String(t > 0.5));
    if (closedFig) closedFig.setAttribute('aria-hidden', String(t <= 0.5));
    var step = Math.min(3, Math.floor(t * 4));
    if (chip) chip.textContent = STEPS[step];
    steps.forEach(function (p, i) { p.setAttribute('data-active', String(i === step)); });
    if (range && Math.abs(Number(range.value) / 100 - t) > 0.01) range.value = String(Math.round(t * 100));
  }
  if (range) range.addEventListener('input', function () { setFold(Number(range.value) / 100); });
  setFold(0);

  function foldScrub() {
    if (reduced || !tall || !stage) return;
    var rect = tall.getBoundingClientRect();
    var total = rect.height - window.innerHeight;
    if (total <= 0) return;
    var t = -rect.top / total;
    if (t >= -0.02 && t <= 1.02) setFold(t);
  }

  /* ---------- carousel (M-15) ---------- */
  var track = document.querySelector('.pf-car-track');
  var prev = document.querySelector('[data-pf-prev]');
  var next = document.querySelector('[data-pf-next]');
  if (track && prev && next) {
    var stepW = function () {
      var card = track.querySelector('.pf-ben-card');
      return card ? card.getBoundingClientRect().width + 24 : 0;
    };
    var syncArrows = function () {
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    };
    prev.addEventListener('click', function () { track.scrollBy({ left: -stepW(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: stepW(), behavior: 'smooth' }); });
    track.addEventListener('scroll', syncArrows, { passive: true });
    window.addEventListener('resize', syncArrows);
    syncArrows();
  }

  /* ---------- count-up (M-13) ---------- */
  if (!reduced && 'IntersectionObserver' in window) {
    var statIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        statIO.unobserve(entry.target);
        var el = entry.target.querySelector('.pf-stat-value');
        if (!el) return;
        var target = Number(entry.target.getAttribute('data-count') || el.textContent);
        var start = null;
        var tick = function (ts) {
          if (start === null) start = ts;
          var p = Math.min(1, (ts - start) / 1100);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = String(Math.round(target * eased));
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('.pf-stat').forEach(function (s) { statIO.observe(s); });
  }

  /* ---------- reveals (gated behind html.pf-js in CSS) ---------- */
  if (!reduced && 'IntersectionObserver' in window) {
    var revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('pf-in'); revealIO.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    document.querySelectorAll('.pf-reveal').forEach(function (el) { revealIO.observe(el); });
  } else {
    document.querySelectorAll('.pf-reveal').forEach(function (el) { el.classList.add('pf-in'); });
  }

  /* ---------- seam floats (M-14) + wordmark parallax (M-12) ---------- */
  var floatEls = Array.prototype.slice.call(document.querySelectorAll('.pf-float'));
  var wordmark = document.querySelector('.pf-wordmark');
  function clamp1(v) { return Math.max(-1, Math.min(1, v)); }
  function floats() {
    if (reduced) return;
    var vh = window.innerHeight;
    floatEls.forEach(function (el) {
      var amount = Number(el.getAttribute('data-float') || 16);
      var r = el.getBoundingClientRect();
      var p = clamp1((r.top + r.height / 2 - vh / 2) / vh);
      el.style.transform = 'translateY(' + (-p * 2 * amount).toFixed(1) + 'px)';
    });
    if (wordmark) {
      var wr = wordmark.parentElement.getBoundingClientRect();
      var wp = clamp1((wr.top + wr.height / 2 - vh / 2) / vh);
      wordmark.style.transform = 'translate(calc(-50% + ' + (wp * -60).toFixed(1) + 'px), -50%)';
    }
  }

  /* ---------- hero video (pause offscreen / reduced motion) ---------- */
  var heroVideo = document.querySelector('.pf-hero-video');
  if (heroVideo) {
    if (reduced) {
      heroVideo.removeAttribute('autoplay');
      heroVideo.pause();
    } else if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          var vp = heroVideo.play();
          if (vp && vp.catch) vp.catch(function () {});
        } else {
          heroVideo.pause();
        }
      }, { threshold: 0.05 }).observe(heroVideo);
    }
  }

  /* ---------- sticky buy bar ---------- */
  var buybar = document.querySelector('.pf-buybar');
  if (buybar && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      buybar.setAttribute('data-visible', String(!entries[0].isIntersecting));
    }).observe(hero);
  } else if (buybar && !hero) {
    buybar.setAttribute('data-visible', 'true');
  }

  syncHeader();
  foldScrub();
  floats();
})();
